// LT-511: time + date formatters for the public booking page.
//
// Slots come from the backend as UTC ISO strings; we display them in the
// host's timezone (BookingPage.calendar.timezone). 09:00 Brisbane stays
// "09:00" when the response carries timezone='Australia/Brisbane'.

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];
const WEEKDAYS_FULL = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
];
export const WEEKDAYS_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const dateFmt = (timeZone: string) =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
  });
const timeFmt = (timeZone: string) =>
  new Intl.DateTimeFormat('en-GB', {
    timeZone, hour: '2-digit', minute: '2-digit', hour12: false,
  });

/** UTC ISO → YYYY-MM-DD in the given timezone. */
export function slotDate(iso: string, timeZone: string): string {
  return dateFmt(timeZone).format(new Date(iso));
}

/** UTC ISO → HH:mm in the given timezone (24h). */
export function slotTime(iso: string, timeZone: string): string {
  return timeFmt(timeZone).format(new Date(iso));
}

/** Add `durationMinutes` to the UTC ISO start and return HH:mm in tz. */
export function endTime(
  startIso: string, durationMinutes: number, timeZone: string,
): string {
  const end = new Date(
    new Date(startIso).getTime() + durationMinutes * 60_000,
  );
  return timeFmt(timeZone).format(end);
}

/** YYYY-MM-DD → "Thursday, May 28". The y/m/d are interpreted as a
 *  wall-clock day in the host's tz, but the weekday name only depends on
 *  the calendar date itself, so we can construct a local Date safely. */
export function formatDayHeading(ymd: string): string {
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return `${WEEKDAYS_FULL[date.getDay()]}, ${MONTHS[m - 1]} ${d}`;
}

/** YYYY-MM-DD for "today" in the given timezone. */
export function todayInTz(timeZone: string): string {
  return slotDate(new Date().toISOString(), timeZone);
}

/** Initials from a display name (e.g. "Ada Lovelace" → "AL"). */
export function initialsOf(name: string | null | undefined): string {
  if (!name) return '?';
  return name.trim().split(/\s+/).map((s) => s[0] ?? '').join('').slice(0, 2).toUpperCase();
}

export { MONTHS };
